import styled from 'styled-components';
import CLFontIcon from '../../components/CLFontIcon';

export const Container = styled.div`

`;

export const Grid2 = styled.div`
  display: grid;

  column-gap: 32px;
  row-gap: 30px;
  grid-template-columns: 3fr 2fr;
  grid-template-areas:
    "base params"
    "features params";

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-areas:
    "base"
    "params"
    "features";
  }

  & > {
    div:nth-of-type(1) {
      grid-area: base;
    }

    div:nth-of-type(2) {
      grid-area: features;
    }

    div:nth-of-type(3) {
      grid-area: params;
    }
  }
`;

export const FeaturesContainer = styled.div`
  display: grid;

  column-gap: 32px;
  row-gap: 24px;
  grid-template-columns: repeat(2, 1fr);
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Feature = styled.div`
  h3 {
    [class*=" cl-"] {
      margin-right: 8px;
    }
  }
`;

export const NotAvailable = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 0 8px;
  height: 30px;
  border: 1px solid rgba(0,0,0,0.08);
  border-radius: 4px;
  color: ${({ color }) => color};
  background-color: ${({ bgColor }) => bgColor};
  box-shadow: 0 1px 3px 0 rgba(0,0,0,0.08), 0 2px 6px 0 rgba(0,0,0,0.08);
  font-size: 14px;

  [class*=" cl-"] {
    margin-right: 8px;
    font-size: 14px;
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: 32px;

  & > button {
    flex: 1;
  }

  @media (max-width: 768px) {
    flex-direction: column-reverse;

    & > button {
      flex: initial;
    }
  }
`;

export const BackIcon = styled(CLFontIcon).attrs(() => ({
  icon: 'caret-left',
}))`
  font-size: 12px;
  margin-right: 8px;
`;
